class CustomEvent extends Event {
    values;
    constructor(type, values) {
        super(type);
        this.values = values;
    }
}

export default CustomEvent;